import { useTranslations } from 'next-intl';
import styled from 'styled-components';
import { Section, SectionHeader, StepList } from '@/components/ui';

// Product types with their own three steps. Other types render nothing.
const TYPES = ['giftcard', 'pin', 'topup'];

const Steps = styled(StepList)`
  margin-top: 48px;
`;

/**
 * "How it works" in three numbered steps.
 *
 * `type` picks the copy: 'giftcard' (default), 'pin' or 'topup'.
 * `background` is any CSS background for the section band.
 */
const HowItWorks = ({ background, type = 'giftcard' }) => {
  const t = useTranslations('howItWorks');

  if (!TYPES.includes(type)) return null;

  const steps = [1, 2, 3].map((step) => ({
    title: t(`${type}.step${step}Title`),
    description: t(`${type}.step${step}Description`),
  }));

  return (
    <Section
      id="how-it-works"
      $background={background && background !== 'transparent' ? background : undefined}
    >
      <SectionHeader eyebrow={t('eyebrow')} title={t(`${type}.title`)} />
      <Steps steps={steps} />
    </Section>
  );
};

export default HowItWorks;
